import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from 'api/request';

export const apiGetSMSupplierDetail = async (id) => {
  return Request.call({
    url: `/micro/suppliers/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const fetchPartners = async (pagination, keywords, filter) => {
  const params = {
    keywords,
    searchBy: 'supplier_name',
    ...filter,
    ...pagination,
  };
  if (!keywords) {
    delete params.keywords;
    delete params.searchBy;
  }
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/partners?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    // params,
  });
};
export const fetchSuppliers = async (pagination, keywords, filter) => {
  const params = {
    keywords,
    searchBy: 'supplier_name',
    ...filter,
    ...pagination,
  };
  if (!keywords) {
    delete params.keywords;
    delete params.searchBy;
  }
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    // params,
  });
};

export const fetchSuppliersNoConnection = async (pagination, keywords) => {
  const params = {
    keywords,
    connectionStatus: ['noConnection', 'invited'],
    searchBy: 'supplier_name',
    ...pagination,
  };
  if (!keywords) {
    delete params.keywords;
    delete params.searchBy;
  }
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    // params,
  });
};

export const inviteSupplier = async (payload) => {
  return Request.call({
    url: `/micro/suppliers/invitations`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: payload,
  });
};

export const validateSupplier = async (email) => {
  return Request.call({
    url: `/micro/suppliers/invitations/validate-supplier`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      email,
    },
  });
};

export const validateInvitationCode = async (code) => {
  return Request.call({
    url: `/micro/suppliers/invitations/validate`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      code,
    },
  });
};

export const apiAcceptInvitation = async (code) => {
  return Request.call({
    url: `/micro/suppliers/invitations/accept`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      codes: code,
    },
  });
};

export const getAwaitingInvitations = async () => {
  return Request.call({
    url: `/micro/suppliers/invitations`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
